import PropTypes from 'prop-types';

import LazyLoad from '../../LazyLoad';

import styles from '../FooterSimplified.module.scss';

const FooterSimplifiedStoreIcon = ({ src, alt }) => (
  <LazyLoad offset={100} once>
    <img className={styles['footer__store-icon']} src={src} alt={alt} />
  </LazyLoad>
);

FooterSimplifiedStoreIcon.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
};

export default FooterSimplifiedStoreIcon;
